/*******************************************************************************************************************
 * File: /assets/js/videoimport.js
 * Initalizes all video player on page. And provides player control for lightboxes
 * 
 * 
 * 
 * Author: Matt Hawk
 *
 *******************************************************************************************************************/

// Init players, may not always be needed but this allows funtions to grap an instantiated player later.
export function initPlayers() {
    if(document.querySelector('#vid-global-success')) {
        import('./playerInit')
        .then(module => {
          module.globalSuccessPlayer();
      });
    }
    if(document.querySelector('#hero-vid-header')) {
        import('./playerInit')
        .then(module => {
          module.heroVidPlayer();
      });
    }
    if(document.querySelector('#vid-success')) {
        import('./playerInit')
        .then(module => {
          module.vidSuccessPlayer();
      });
    }
};

// Start lightbox playback
export function lightBoxVidStart(dataSrc, dataPoster) {
    import('./playerInit')
    .then(module => {
        module.lightBoxVidPlayer(dataSrc, dataPoster);
    }
    );
};

// End lightbox playback
export function lightBoxVidPause() {
    import('./playerInit')
    .then(module => {
        module.lightBoxVidPause();
    }
    );
};

